class NewsletterForm extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.DefaultForm = this.querySelector('form#ContactFooter');
		if (!this.DefaultForm) {
			console.error('DefaultForm not found');
			return;
		}

		this.DefaultFormEmail = this.DefaultForm.querySelector(
			'input[type="email"]'
		);

		this.bindEvents();
	}

	bindEvents() {
		this.DefaultFormEmail.addEventListener(
			'input',
			this.cloneForm.bind(this)
		);
		this.DefaultForm.addEventListener(
			'submit',
			this.submitForm.bind(this)
		);
	}

	cloneForm(event) {
		this.KlaviyoFormEmail = event.target.value;
	}

	createSubscriptionObject () {
		const options = {
			method: 'POST',
			headers: {
				revision: '2023-08-15',
				'content-type': 'application/json',
			},
			body: JSON.stringify({
				data: {
					type: 'subscription',
					attributes: {
						custom_source: 'footer signup form',
						profile: {
							data: {
								type: 'profile',
								attributes: {
									email: this.KlaviyoFormEmail,
								},
							},
						},
					},
					relationships: {
						list: { data: { type: 'list', id: 'XfTR4Z' } },
					},
				},
			}),
		};
		return options;
	}

	submitForm() {
		const options = this.createSubscriptionObject();
		fetch('https://a.klaviyo.com/client/subscriptions/?company_id=RPZWkF', options)
			.then((response) => response.json())
			.then((response) => console.log(response))
			.catch((err) => console.error(err));
	}
}

customElements.define('footer-newsletter-form', NewsletterForm);
